<div class="device-short-info-container">
  <div class="content" *ngIf="device">
    <div class="groupheader">
      <div class="heading"> {{ 'basket.deviceInfo.headline.device' | translate }} </div>
      <div class="heading hideOnPhone"> {{ 'basket.deviceInfo.headline.customer' | translate }} </div>
    </div>
    <div class="truck detailblocks">
      <div class="detailheader">
        <ng-container *ngIf="device?.truckSeries?.images as images; else noImage">
          <img
            *ngIf="images[0] as img"
            [lazyLoad]="img.url + '?width=200&height=200&padColor=fff'"
            [defaultImage]="img.url + '?width=50&height=50&padColor=fff'"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            src="#"
            [alt]="img.altText"
            [title]="img.titleText"
            width="121px"
            height="auto" />
        </ng-container>
        <ng-template #noImage>
          <img
            lazyLoad="./assets/ui/shared/error/not_found_error_image.png"
            defaultImage="./assets/ui/shared/error/not_found_error_image.png"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            src="#"
            alt="missing_truck"
            title="missing_truck"
            width="121px"
            height="auto" />
        </ng-template>
        <div class="text">
          <ng-container *ngIf="enableDeviceLink && device.id; else noLink">
            <a class="title" [href]="deviceLink">
              {{ device.serialNumber }}
            </a>
          </ng-container>
          <ng-template #noLink>
            <div class="title">{{ device.serialNumber }}</div>
          </ng-template>
          <div class="subtitle" *ngIf="device?.equipmentDescription as code; else noCode">{{ code }}</div>
          <ng-template #noCode>
            <div class="subtitle"> {{ 'deviceInfo.label.empty' | translate }} </div>
          </ng-template>
        </div>
      </div>
      <div class="detailheader noimage">
        <div class="text">
            <ng-container *ngIf="device.id && device.addressOwner; else noOwner">
                <div class="title" *ngIf="device.addressOwner as owner">{{ owner.companyName }}</div>
                <div class="subtitle" *ngIf="device.addressLocation as location"> {{ location.town }} </div>
            </ng-container>
            <ng-template #noOwner>
                <div class="subtitle"> {{ 'deviceInfo.label.empty' | translate }} </div>
            </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
